import React from "react";

import CommercialFlightDetails from "./commercialflightdetails";
import PrivateFlightDetails from "./privateflightdetails";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

interface Props {
  flight: server.dto.Flight
  segment: server.dto.FlightSegment
  onEditClicked: (segment: server.dto.FlightSegment) => void
  onDeleteClicked: (segment: server.dto.FlightSegment) => void
}

const FlightHeader = (props: Props) => (<div className="margin-bottom padding-bottom-large flex border-bottom gap">
  <div className="grow1">
    <h3>{props.segment.description} : {props.segment.title}</h3>
  </div>

  {props.flight.permissions.canDelete && <PhosphorTrashButton
    layout="in-square"
    onClick={() => { props.onDeleteClicked(props.segment); }}
  />}

  {props.flight.permissions.canModify && <PhosphorPencilButton
    layout="in-square"
    onClick={() => { props.onEditClicked(props.segment); }}
  />}
</div >);

const StartDate = ({ departure }: { departure: server.dto.FlightSegmentDepartureArrival }) => (<div className="flex margin-bottom-large gap">
  <div className="grow1 big_text">{formatWrittenDayMonthYear(departure.dateTimeLocal)}</div>
  <div className="big_text">{formatTime(departure.dateTimeLocal)}</div>
  <div><i className="icon-arrow-right small" /></div>
</div>);

const EndDate = ({ segment }: { segment: server.dto.FlightSegment }) => {
  const arrivesOnDifferentDate = segment.arrival.dateTimeLocal !== segment.departure.dateTimeLocal;

  return (<div className="flex margin-bottom-large big_text">
    {arrivesOnDifferentDate && `${formatWrittenDayMonthYear(segment.arrival.dateTimeLocal)} ${formatTime(segment.arrival.dateTimeLocal)}`}
    {!arrivesOnDifferentDate && `${formatTime(segment.arrival.dateTimeLocal)}`}
  </div>);
};

const Airport = ({ details }: { details: server.dto.FlightSegmentDepartureArrival }) => (<>
  <div className="margin-bottom-small">{details.airport.name} [{details.airport.iata}]</div>
  <div className="s1_gray margin-bottom-small">{details.airport.location}</div>
  {details.terminal && <div className="s1_gray margin-bottom-small">terminal {details.terminal}</div>}
  {details.gate && <div className="s1_gray">gate {details.gate}</div>}
</>);

export default class FlightSegment extends React.Component<Props> {
  public render(): JSX.Element {
    const { segment } = this.props;

    return <>
      <div className="flex-column ">

        <FlightHeader
          flight={this.props.flight}
          segment={this.props.segment}
          onDeleteClicked={this.props.onDeleteClicked}
          onEditClicked={this.props.onEditClicked} />

        <div className="flex gap">
          <div style={{ flexBasis: 400 }}>
            <StartDate departure={segment.departure} />
            <Airport details={segment.departure} />
          </div>
          <div className="grow1">
            <EndDate segment={segment} />
            <Airport details={segment.arrival} />
          </div>
        </div>

        <div className="border-top margin-top padding-top">

          <table className="s1_table clean rowspace-small">
            <tbody>

              {segment.type === "commercial"
                ? <CommercialFlightDetails segment={segment} />
                : <PrivateFlightDetails segment={segment} />}
              {segment.linkedShows.length > 0 && <tr>
                <td>{RESX.GeneralLabels.LinkedTo}</td>
                <td><LinkedShowsList onChange={() => {}} shows={segment.linkedShows} /></td>
              </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>;
  }
}
